/** Prefix for AI agent assignees on Wave todo items (e.g. `agent:assistente`). */
export const WAVE_TODO_AGENT_PREFIX = "agent:";
/** Known AI agents assignable to Wave todo items. */
export const WAVE_TODO_AI_AGENTS = [
    { id: "agent:assistente", label: "Assistente", glyph: "🤖" },
];
export function isWaveTodoAgentAssignee(ref) {
    return ref.startsWith(WAVE_TODO_AGENT_PREFIX);
}
export var WaveCROpKind;
(function (WaveCROpKind) {
    WaveCROpKind["ReplaceDocument"] = "replaceDocument";
    WaveCROpKind["InsertBlock"] = "insertBlock";
    WaveCROpKind["UpdateBlock"] = "updateBlock";
    WaveCROpKind["DeleteBlock"] = "deleteBlock";
    WaveCROpKind["MoveBlock"] = "moveBlock";
})(WaveCROpKind || (WaveCROpKind = {}));
export function encodeWaveCROpB64(op) {
    try {
        const json = JSON.stringify(op);
        return btoa(unescape(encodeURIComponent(json)));
    }
    catch {
        return null;
    }
}
export function decodeWaveCROpB64(b64) {
    try {
        const json = decodeURIComponent(escape(atob(b64)));
        return JSON.parse(json);
    }
    catch {
        return null;
    }
}
export function newBlockId() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `block-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
export function newCommentId() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `cmt-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
export function newTodoItemId() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `todo-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
export function newGalleryItemId() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `gal-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
export function emptySnapshot() {
    return { blocks: [], version: 1 };
}
export function decodeSnapshotB64(b64) {
    if (!b64)
        return null;
    try {
        const raw = atob(b64);
        try {
            return JSON.parse(raw);
        }
        catch {
            const json = decodeURIComponent(escape(raw));
            return JSON.parse(json);
        }
    }
    catch {
        return null;
    }
}
export function encodeSnapshotB64(snapshot) {
    try {
        const json = JSON.stringify(snapshot);
        return btoa(unescape(encodeURIComponent(json)));
    }
    catch {
        return null;
    }
}
